"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useUsername;

var _useWebChatAPIContext = _interopRequireDefault(require("./internal/useWebChatAPIContext"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function useUsername() {
  return [(0, _useWebChatAPIContext.default)().username];
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9ob29rcy91c2VVc2VybmFtZS50cyJdLCJuYW1lcyI6WyJ1c2VVc2VybmFtZSIsInVzZXJuYW1lIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQUE7Ozs7QUFFZSxTQUFTQSxXQUFULEdBQWlDO0FBQzlDLFNBQU8sQ0FBQyxxQ0FBdUJDLFFBQXhCLENBQVA7QUFDRCIsInNvdXJjZVJvb3QiOiJjb21wb25lbnQ6Ly8vIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHVzZVdlYkNoYXRBUElDb250ZXh0IGZyb20gJy4vaW50ZXJuYWwvdXNlV2ViQ2hhdEFQSUNvbnRleHQnO1xuXG5leHBvcnQgZGVmYXVsdCBmdW5jdGlvbiB1c2VVc2VybmFtZSgpOiBbc3RyaW5nXSB7XG4gIHJldHVybiBbdXNlV2ViQ2hhdEFQSUNvbnRleHQoKS51c2VybmFtZV07XG59XG4iXX0=